import { useContext, useEffect, useState } from 'react';
import * as S from './styles';
import { TranslationContext } from '../../handlers/TranslationsHandler';
import { languageConversion, localeDate } from '../../helpers/dateTime';

export const DateTime = () => {
  const [dateTime, setDateTime] = useState(new Date());

  const { language } = useContext(TranslationContext);

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <S.DateTime>
      <div className="date">
        {dateTime.toLocaleTimeString(languageConversion[language])}
      </div>
      <div className="time">{`${localeDate(language)}`}</div>
    </S.DateTime>
  );
};
